import { render, staticRenderFns } from "./TabelaRequisicaoGofsTesoureiro.vue?vue&type=template&id=604c9914&scoped=true&"
import script from "./TabelaRequisicaoGofsTesoureiro.vue?vue&type=script&lang=js&"
export * from "./TabelaRequisicaoGofsTesoureiro.vue?vue&type=script&lang=js&"
import style0 from "./TabelaRequisicaoGofsTesoureiro.vue?vue&type=style&index=0&id=604c9914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604c9914",
  null
  
)

export default component.exports